import { Button, Form, notification } from 'antd';
import { AuthLoginPayload, useLoginMutation } from 'app/services/edpApiV1/auth';
import { utils } from 'shared/helpers';
import { EmailField, PasswordField } from 'shared/ui/form';
import { useNavigate } from 'react-router-dom';
import { useEffect, useState } from 'react';
import { divideToPairs } from 'shared/helpers/utils';
import { clientCookies } from '../../../../../shared/lib';

import style from './index.module.scss';

export const LoginForm = () => {
  const [login, { isLoading }] = useLoginMutation();
  const [email, setEmail] = useState('');
  const [dividedEmail, setDividedEmail] = useState<string[]>([]);
  const [password, setPassword] = useState('');
  const [valid, setValid] = useState(false);

  const [form] = Form.useForm();

  const navigate = useNavigate();

  useEffect(() => {
    setDividedEmail(divideToPairs(email));
  }, [email]);

  const updateValidate = () => {
    form
      .validateFields({ validateOnly: false })
      .then(data => setValid(true))
      .catch(e => setValid(false));
  };

  const onPasswordChange = (val: string) => {
    setPassword(val);
    updateValidate();
  };
  const onEmailChange = (val: string) => {
    setEmail(val);
    updateValidate();
  };

  const onFinish = async (payload: AuthLoginPayload) => {
    try {
      const credentials = await login(payload).unwrap();
      if (credentials.isNeedChangePassword && !credentials.token) {
        navigate('/login/changePass');
      } else {
        clientCookies.setCredentials(credentials);
      }
    } catch (e) {
      const responseErr = utils.getErrorData(e);
      if (responseErr) notification.error({ message: responseErr.message });
    }
  };

  return (
    <div className={style.root}>
      <Form form={form} className={style.form} size="large" onFinish={onFinish}>
        <h1 className={style.header}>Войти</h1>
        <EmailField onChange={onEmailChange} />
        <PasswordField
          onChange={onPasswordChange}
          toValidate={false}
          rules={[
            {
              pattern: new RegExp(`^(?!.*(${dividedEmail.join('|')})).*$`),
              message: 'Пароль не должен содержать два подряд идущих символа из логина',
            },
          ]}
        />
        <Button loading={isLoading} type="primary" className={style.button} htmlType="submit" disabled={!valid}>
          Войти
        </Button>
      </Form>
    </div>
  );
};
